import {emotionStyled} from '@packages/utilities/styled';

import {CardBody} from '../../Card';

export const ModalBodyView = emotionStyled(CardBody)(
  {
    fontSize: '$body',
    flex: 1,
    position: 'static', // override 'relative' to not make this a containing box for positioned elements
    padding: '$3',
  },
  {}
);
